import { useEffect, useState } from "react";
import { Share, PlusSquare, Download, Check } from "lucide-react";
import { isStandalone } from "@/lib/appMode";

const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export default function InstallGuide({ app }) {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());
  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);
  if (installed) return null;
  const install = async () => {
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setInstalled(true);
    setPrompt(null);
  };
  return (
    <section data-testid="install-guide" className="border border-[#D9B47A]/25 bg-[#0D0908] p-6">
      <div className="flex items-center gap-4">
        <img src={app.icon} alt="" className="w-14 h-14 rounded-2xl shrink-0" />
        <div>
          <p className="font-display text-xl">Add {app.name} to your home screen</p>
          <p className="mt-1 text-sm text-[#A8998C]">It opens full screen with its own icon, and feels like any other app.</p>
        </div>
      </div>
      {prompt ? (
        <button data-testid="install-button" onClick={install} className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#D9B47A] text-[#0A0706] px-5 py-3 font-tt-mono text-[11px] uppercase tracking-[0.2em] hover:bg-[#F2E8DF] transition-colors">
          <Download className="w-4 h-4" /> Install {app.short}
        </button>
      ) : isIOS() ? (
        <ol data-testid="install-steps-ios" className="mt-5 space-y-3 text-[15px] text-[#CFC2B6]">
          <li className="flex items-center gap-3"><span className="font-tt-mono text-[#D9B47A]">1</span> Open this page in Safari</li>
          <li className="flex items-center gap-3"><span className="font-tt-mono text-[#D9B47A]">2</span> Tap <Share className="w-4 h-4 text-[#D9B47A]" /> Share at the bottom of the screen</li>
          <li className="flex items-center gap-3"><span className="font-tt-mono text-[#D9B47A]">3</span> Choose <PlusSquare className="w-4 h-4 text-[#D9B47A]" /> Add to Home Screen, then Add</li>
        </ol>
      ) : (
        <ol data-testid="install-steps-other" className="mt-5 space-y-3 text-[15px] text-[#CFC2B6]">
          <li className="flex items-center gap-3"><span className="font-tt-mono text-[#D9B47A]">1</span> Open this page in Chrome on your phone</li>
          <li className="flex items-center gap-3"><span className="font-tt-mono text-[#D9B47A]">2</span> Tap the ⋮ menu, then Install app or Add to Home screen</li>
          <li className="flex items-center gap-3"><Check className="w-4 h-4 text-[#D9B47A]" /> {app.name} appears with its own icon</li>
        </ol>
      )}
    </section>
  );
}
